{{ statusText | translate }}
<ng-content select="[afterStatus]"></ng-content>
